var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4124 4C6.1124 4 9.1499 12.2125 9.1499 12.2125C9.8249 13.3375 10.7249 13.1125 10.7249 13.9C10.7249 14.575 9.9374 14.8 9.1499 14.9125C7.9124 14.9125 6.7874 14.6875 5.6624 16.7125C4.9874 17.95 4.6499 22 4.6499 22H20.0624C20.0624 22 19.7249 17.95 19.1624 16.7125C18.0374 14.575 16.9124 14.9125 15.6749 14.8C14.8874 14.6875 14.0999 14.4625 14.0999 13.7875C14.0999 13.1125 14.9999 13.3375 15.6749 12.1C15.6749 12.2125 18.7124 4 12.4124 4Z",
    fill: "#CF283A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRed);
export default __webpack_public_path__ + "static/media/user-red.b45df07514b4342a4f31a73eca42230b.svg";
export { ForwardRef as ReactComponent };